<div class="modal fade" id="setting-modal" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <app-setting-component class="modal-content rounded rounded-900 shadow-modal shadow-modal"
                           *ngIf="activeModal ==='setting-modal'"></app-setting-component>
  </div>
</div>
